export default __webpack_public_path__ + "8e202334c995e18a1063915b7ede452a.svg";